import { Column, Table as ReactTable } from "@tanstack/react-table"
import Grid from "../Grid"
import Input from "../Input"
import { styles } from "../../utils/commonStyles"

function Filter({
    column,
    table,
    setPrevPage,
    prevIndex
}: {
    column: Column<any, any>
    table: ReactTable<any>
    setPrevPage: (p: number) => void
    prevIndex: number
}) {
    const firstValue = table
        .getPreFilteredRowModel()
        .flatRows[0]?.getValue(column.id)

    const columnFilterValue = column.getFilterValue()
    const currentPage = table.getState().pagination.pageIndex + 1

    const handlePageLogic = (value: string) => {
        if (value && value !== '') {
            if (prevIndex === -1) {
                setPrevPage(table.getState().pagination.pageIndex)
            }

            if (currentPage !== 0) {
                table.setPageIndex(0)
            }
        } else {
            table.setPageIndex(prevIndex); // Filter törlése után visszatérünk az előző oldalra
            setPrevPage(-1)
        }
    }

    return typeof firstValue === 'number' ? (
        <div style={styles.marginTop8}>
            <Grid.Container>
                <Grid.Col>
                    <Input
                        style={{ minWidth: 100 }}
                        value={(columnFilterValue as [number, number])?.[0] ?? ''}
                        onChangeValue={value => {
                            column.setFilterValue((old: [number, number]) => [
                                String(value),
                                old?.[1],
                            ])

                            handlePageLogic(String(value))
                        }}

                        variant="number"
                        placeholder={`Min`}
                        size='small'
                        icon={'pin_outlined'}
                    />
                </Grid.Col>
                <Grid.Col>
                    <Input
                        style={{ minWidth: 100 }}
                        value={(columnFilterValue as [number, number])?.[1] ?? ''}
                        onChangeValue={value => {
                            column.setFilterValue((old: [number, number]) => [
                                old?.[0],
                                String(value),
                            ])

                            handlePageLogic(value)
                        }}
                        variant="number"
                        placeholder={`Max`}
                        size='small'
                        icon={'pin_outlined'}
                    />
                </Grid.Col>
            </Grid.Container>
        </div>
    ) : (
        <Input
            style={{ ...styles.marginTop8, ...{ minWidth: 150 } }}
            value={(columnFilterValue ?? '') as string}
            onChangeValue={value => {
                column.setFilterValue(String(value))
                handlePageLogic(value)
            }}
            variant="text"
            placeholder={`Keresés...`}
            size='small'
            icon={'search'}
        />
    )
}

export default Filter